<script setup lang="ts">
import type {MenuItemInterface} from "~~/server/types/menu";

defineProps<{
  item: MenuItemInterface;
  idx: number;
}>();

</script>

<template>
  <nav class="panel panel-full panel--mega_with_sub_categories2"
       :id="`panel-${idx}`"
       :aria-label="item.name">

    <ul class="panel-items" role="list">
      <li v-for="(col, ck) in item.children" :key="ck" class="item">
        <div class="level_1 pb-3">
          <img
              :src="col.icon"
              class="image"
              loading="lazy"
              decoding="async"
              style="object-fit: contain;"
              :alt="col.name"  />

          <NuxtLinkLocale
              :to="col.url"
              class="title fs--11 fw-semibold "
              :aria-label="col.name">
            {{ col.name }}
          </NuxtLinkLocale>
        </div>

        <ul class="level_2" role="list" v-if="(col.children || []).length">
          <li v-for="(inner, ik) in col.children || []" :key="ik" class="pb-1">
            <NuxtLinkLocale
                :to="inner.url"
                class="title fw-normal fs--11"
                :aria-label="inner.name">
              {{ inner.name }}
            </NuxtLinkLocale>
          </li>
        </ul>
      </li>
    </ul>

    <div class="panel-footer d-flex justify-content-end" :aria-label="`${item.name} footer`">

      <NuxtLinkLocale
          :to="item.url"
          class="panel-view_all el-button el-button--primary el-button--default is-round"
          :aria-label="`${$t('view_all')} – ${item.name}`"
          :title="`${$t('view_all')} – ${item.name}`">
        {{$t('view_all')}}
      </NuxtLinkLocale>
    </div>
  </nav>
</template>

<style scoped lang="scss">
.panel--mega_with_sub_categories2 {
  padding: 10px 15px 15px!Important;
  .panel-items {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 15px;
    padding: 20px 0 ;
    list-style: none;

    @media screen and (max-width: 992px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .title {
      color: var(--nav-panel-text);

      &:hover,
      &:focus-visible {
        color: var(--nav-panel-text-hover);
      }
    }

    .level_1{
      display: flex;
      align-items: center;
      min-width: 0;
      gap:16px;

      .title{
        flex: 1 1 auto;
        min-width: 0;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: anywhere;
        text-transform: uppercase;
      }
    }
    .level_2{
      li{
        list-style: none;
      }
    }
  }

  .item {
    border-right: 1px solid #e5e5e5;
    padding: 0 15px;
    &:nth-child(4n) {
      border-right: none;
    }
    &:hover {
    }
  }

  .level_1 .image {
    width: 50px;
    border-radius: 10px;
  }
  .panel-footer{
    padding-top: 10px;
    border-top: 1px solid #e5e5e5 ;
  }
}
</style>
